import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import {
    FacebookShareButton,
    PinterestShareButton,
    RedditShareButton,
    TwitterShareButton,
    FacebookIcon,
    PinterestIcon,
    RedditIcon,
    TwitterIcon,
} from 'react-share';

import FONTS from '@mlb/react-patterns/style/fonts';

import { getShareContentType } from '../../utils';

const List = styled.ul`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-bottom: 20px;
    font-family: ${FONTS.primaryFont};
`;

const ListItem = styled.li`
    cursor: pointer;
`;

const SocialList = ({
    firstFocusedNode,
    mediaPlayback,
    link,
    config,
    dictionary,
    lang,
    onShare,
}) => {

    const blurb = _get(mediaPlayback, 'blurb', '');
    const description = _get(mediaPlayback, 'description', '');
    const imageSrc = _get(mediaPlayback, 'feeds[0].image.cuts[0].src', '');
    const slug = _get(mediaPlayback, 'slug', '');
    const title = _get(mediaPlayback, 'title', '');
    const contentType = getShareContentType(mediaPlayback);

    return (
        <List>
            <ListItem
                ref={firstFocusedNode}
                tabIndex={'-1'}
                onClick={() => {

                    onShare({
                        type: 'Facebook',
                        slug,
                        title,
                        contentType,
                    });
                
                }}
            >
                <FacebookShareButton
                    url={link}
                    aria-label={_get(dictionary, 'share_with_facebook_text', 'Share on Facebook')}
                >
                    <FacebookIcon
                        size={50}
                        round={true}
                    />
                </FacebookShareButton>
            </ListItem>
            <ListItem
                onClick={() => {

                    onShare({
                        type: 'Twitter',
                        slug,
                        title,
                        contentType,
                    });
                
                }}
            >
                <TwitterShareButton
                    title={blurb}
                    url={link}
                    via={_get(config, `shareConfig.twitterHandle.${lang}`, 'MLB')}
                    aria-label={_get(dictionary, 'share_with_twitter_text', 'Share on Twitter')}
                    hashtags={_get(config, 'shareConfig.twitterHashtags', '')}
                >
                    <TwitterIcon
                        size={50}
                        round={true}
                    />
                </TwitterShareButton>
            </ListItem>
            <ListItem
                onClick={() => {

                    onShare({
                        type: 'Reddit',
                        slug,
                        title,
                        contentType,
                    });
                
                }}
            >
                <RedditShareButton
                    url={link}
                    aria-label={_get(dictionary, 'share_with_reddit_text', 'Share on Reddit')}
                >
                    <RedditIcon
                        size={50}
                        round={true}
                    />
                </RedditShareButton>
            </ListItem>
            <ListItem
                onClick={() => {

                    onShare({
                        type: 'Pinterest',
                        slug,
                        title,
                        contentType,
                    });
                
                }}
            >
                <PinterestShareButton
                    url={link}
                    media={imageSrc}
                    description={description}
                    aria-label={_get(dictionary, 'share_with_pinterest_text', 'Share on Pinterest')}
                >
                    <PinterestIcon
                        size={50}
                        round={true}
                    />
                </PinterestShareButton>
            </ListItem>
        </List>
    );

};

SocialList.propTypes = {
    firstFocusedNode: PropTypes.object,
    mediaPlayback: PropTypes.object,
    link: PropTypes.string,
    config: PropTypes.object,
    dictionary: PropTypes.object,
    lang: PropTypes.string,
    onShare: PropTypes.func,
};

SocialList.defaultProps = {
    firstFocusedNode: undefined,
    mediaPlayback: {},
    link: 'https://www.mlb.com',
    config: {},
    dictionary: {},
    lang: 'en',
    onShare: _noop,
};

export default SocialList;
